import styled from 'styled-components'

import { COLORS } from '../Colors'

export type TextInputComponentProps = {
    labelText: string
    name: string
    onChange: (value: string, name: string) => void | null
    getValue: (name: string) => any
    isTextArea?: boolean
    placeholder?: string
    maxLength?: number
    helperText?: string
    showCounter?: boolean
}

function TextInputComponent({
    labelText,
    name,
    onChange,
    getValue,
    isTextArea,
    placeholder = '',
    maxLength,
    helperText,
    showCounter,
}: TextInputComponentProps): JSX.Element {
    const currentValue = String(getValue(name) || '')
    const currentLength = currentValue.length

    if (isTextArea)
        return (
            <InputContainer>
                <InputLabel htmlFor={`id-${labelText}`}>{labelText}</InputLabel>
                <TextArea
                    name={name}
                    id={`id-${labelText}`}
                    onChange={({ target }) =>
                        onChange(target.value, target.name)
                    }
                    value={currentValue}
                    placeholder={placeholder}
                    maxLength={maxLength}
                />
                {(helperText || (showCounter && maxLength)) && (
                    <HelperText>
                        {helperText}
                        {showCounter && maxLength
                            ? `${
                                  helperText ? ' · ' : ''
                              }${currentLength}/${maxLength}`
                            : ''}
                    </HelperText>
                )}
            </InputContainer>
        )

    return (
        <InputContainer>
            <InputLabel htmlFor={`id-${labelText}`}>{labelText}</InputLabel>
            <TextInput
                id={`id-${labelText}`}
                onChange={({ target }) => onChange(target.value, name)}
                value={currentValue}
                placeholder={placeholder}
                maxLength={maxLength}
            />
            {(helperText || (showCounter && maxLength)) && (
                <HelperText>
                    {helperText}
                    {showCounter && maxLength
                        ? `${
                              helperText ? ' · ' : ''
                          }${currentLength}/${maxLength}`
                        : ''}
                </HelperText>
            )}
        </InputContainer>
    )
}

TextInputComponent.defaultProps = {
    isTextArea: false,
}

const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
`

const InputLabel = styled.label`
    text-transform: uppercase;
    font-family: Roboto;
    font-weight: bold;
    font-size: 12px;
    color: ${COLORS.primaryGray};
    line-height: 2;
`

const TextInput = styled.input`
    font-family: Roboto;
    height: 20px;
    border: 1px solid ${COLORS.borderGray};
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
    line-height: 1.43;
    :focus {
        outline: none;
    }
`

const TextArea = styled.textarea`
    font-family: Roboto;
    height: 100px;
    border: 1px solid ${COLORS.borderGray};
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
    line-height: 1.43;
    :focus {
        outline: none;
    }
    resize: none;
`

const HelperText = styled.span`
    font-family: Roboto;
    font-size: 10px;
    color: ${COLORS.primaryGray};
    margin-top: 4px;
`

export default TextInputComponent
